import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { unopenAlertModal } from "../../actions/ui";
import Button from "../atoms/Button";
import Modal from "./Modal";

const AlertModal = () => {
    const { open, title, message } = useSelector(
        ({ ui: { alertModal } }: any) => alertModal
    );
    const dispatch = useDispatch();

    const closeModal = useCallback(
        () => dispatch(unopenAlertModal()),
        [dispatch]
    );

    return (
        <Modal
            className="alert-modal"
            active={open}
            onOverlayClick={closeModal}
        >
            <Modal.Header hideClose={true}>{title}</Modal.Header>
            <Modal.Content>
                <div
                    className="alert-modal__message"
                    dangerouslySetInnerHTML={{ __html: message }}
                ></div>
                <div className="alert-modal__button">
                    <Button styles={["green", "small"]} onClick={closeModal}>
                        OK
                    </Button>
                </div>
            </Modal.Content>
        </Modal>
    );
};

export default AlertModal;
